
var Model = require("../types/Model.js");

var RECALCULATE_DELAY = 200; // 200 milliseconds

module.exports = Model({
	name: "callmagnifier",
	init: init,
	triggers: triggers,
});

function init() {
	this.push(false);
}

function triggers() {
	return {
		"toggle": toggle,
		"init": init
	};
}

function toggle() {
	var newState = !this.data;
	setTimeout(recalculate.bind(this), RECALCULATE_DELAY);
	this.push(newState);
}

function recalculate() {
	this.emit("buzz:trigger:video:recalculate");
}
